import { Image as ImageIcon } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface ImageViewerProps {
	url: string | null | undefined;
	name: string;
	lightBg: boolean;
}

export function ImageViewer({ url, name, lightBg }: ImageViewerProps) {
	return (
		<div
			className={cn(
				'flex h-full items-center justify-center p-6 transition-colors duration-200',
				lightBg ? 'bg-stripes-light' : 'bg-stripes-dark'
			)}
		>
			{url ? (
				<img
					src={url}
					alt={name}
					className="max-h-full max-w-full select-none rounded-md object-contain"
					draggable={false}
				/>
			) : (
				<div className="flex h-48 w-48 items-center justify-center rounded-xl border border-line-1 bg-surface">
					<ImageIcon size={40} className="text-text-4" />
				</div>
			)}
		</div>
	);
}
